var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMemo } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { timePointsApi } from '@data/rest/api';
import { TagQueryKeys } from '@data/tag/types';
var QUERY_KEY = ['timePoints'];
function getTimePoints() {
    return timePointsApi.list();
}
export function useTimePoints(options) {
    return useQuery(QUERY_KEY, getTimePoints, __assign({ staleTime: 5000 }, options));
}
function filterActiveTimePoints(timePoints) {
    return timePoints.filter(function (dt) { return dt.active; });
}
export function useActiveTimePoints() {
    var data = useTimePoints({ notifyOnChangeProps: ['data'], select: filterActiveTimePoints }).data;
    var activeTimePoints = useMemo(function () { return data !== null && data !== void 0 ? data : []; }, [data]);
    return activeTimePoints;
}
export function useActiveYears() {
    var timePoints = useActiveTimePoints();
    var yearSet = useMemo(function () {
        var set = new Set(timePoints.map(function (tp) { return tp.year; }));
        return Array.from(set);
    }, [timePoints]);
    return yearSet;
}
export function useYearsActions() {
    var _this = this;
    var queryClient = useQueryClient();
    var add = useMutation(function (year) { return timePointsApi.createYear({ year: year }); }, {
        onSettled: function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(QUERY_KEY);
                queryClient.invalidateQueries(TagQueryKeys.Tags);
                return [2 /*return*/];
            });
        }); },
    });
    var update = useMutation(function (_a) {
        var year = _a.year, active = _a.active;
        return timePointsApi.updateYear(year, { active: active });
    }, {
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(QUERY_KEY);
                queryClient.invalidateQueries(['currentUserSettings']);
                queryClient.invalidateQueries(TagQueryKeys.Tags);
                return [2 /*return*/];
            });
        }); },
    });
    var remove = useMutation(function (year) { return timePointsApi.removeYear(year); }, {
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(QUERY_KEY);
                queryClient.invalidateQueries(TagQueryKeys.Tags);
                return [2 /*return*/];
            });
        }); },
    });
    return {
        createYear: add.mutateAsync,
        updateYear: update.mutateAsync,
        deleteYear: remove.mutateAsync,
    };
}
